import { useAuth } from '@clerk/react'
import {
  Center,
  Loader,
  Paper,
  Stack,
  Text,
  Button,
  Container
} from '@mantine/core'
import { IconLock } from '@tabler/icons-react'
import AuthButton from './AuthButton'

function ProtectedRoute({
  children,
  fallback = null,
  requireAuth = true,
  redirectTo = null,
  showLoader = true,
}) {
  const { isLoaded, isSignedIn } = useAuth()

  if (!isLoaded && showLoader) {
    return (
      <Center h="100vh">
        <Stack align="center" gap="md">
          <Loader size="lg" />
          <Text size="sm" c="dimmed">
            Checking authentication...
          </Text>
        </Stack>
      </Center>
    )
  }

  if (requireAuth && !isSignedIn) {
    if (fallback) return fallback

    if (redirectTo) {
      window.location.href = redirectTo
      return null
    }

    return (
      <Container size="sm" py="xl">
        <Paper shadow="md" p="xl" radius="md" withBorder>
          <Stack align="center" gap="lg">
            <IconLock size={64} color="var(--mantine-color-pink-6)" />
            <Text size="xl" fw={600} ta="center">
              Authentication Required
            </Text>
            <Text size="sm" c="dimmed" ta="center">
              You need to sign in to access this content.
            </Text>
            <AuthButton size="lg" />
          </Stack>
        </Paper>
      </Container>
    )
  }

  return children
}

export default ProtectedRoute
